;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	
	var Collection 	= APP.module('Collection');
	var Model 		= APP.module('Model');
	
	Collection.LeaguesRegenerationInvites =  Collection.Invites.extend({
		model: Model.LeaguesRegenerationInvite,
		fetchFromLeague: function(league_id){
			var d = $.Deferred(),
				league = new Model.LeagueRegeneration(),
				complete = [
					league.show_regenerate().fetch({ data:{ id: league_id } })
				];

			$.when.apply(null, complete).done(function(){
				if(league.get('users')) {
					_.each(league.get('users'), function(contact){
						this.add({
							first_name: 	contact.first_name,
							email:    	 	contact.email
						});
					}, this);
				}
				d.resolve();
			}.bind(this));

			return d.promise();
		}
	});

}(window, APP, Backbone, Marionette, $, _));